import React from 'react';
import Footer from '../../components/footer/footer';
import Head from '../../components/head/head.js'
import RentalInfo from '../../components/rentalinfo/rentalinfo';

function RentServices() {
  return (
    <>
      {/* <React.StrictMode> */}
      <Head />
      <RentalInfo />
      <Footer />
      {/* </React.StrictMode> */}
    </>
  );
}

export default RentServices;
